import { Chip } from "@mui/material";
import PropTypes from "prop-types";
import { SCREENING_KIND } from "./llmUtils";

const LABELS = {
  [SCREENING_KIND.CLASSIFIER]: "Classifier",
  [SCREENING_KIND.LLM]: "LLM screening",
};

/**
 * Read-only badge naming what screens for a template. The kind is a
 * cap-llm-screening surface, so the badge renders nothing unless the parent
 * passes the gate as open (or when the backend sent no kind). The parent
 * reads the flag once, so a list of rows holds no per-row subscription.
 */
const ScreeningKindBadge = ({
  screeningKind,
  llmScreeningEnabled,
  testId,
  sx,
}) => {
  if (!llmScreeningEnabled || !LABELS[screeningKind]) return null;
  return (
    <Chip
      // a span so the badge can sit inline inside text (the list's ID line)
      component="span"
      size="small"
      variant="outlined"
      color={screeningKind === SCREENING_KIND.LLM ? "secondary" : "default"}
      label={LABELS[screeningKind]}
      data-testid={testId}
      sx={sx}
    />
  );
};

ScreeningKindBadge.propTypes = {
  screeningKind: PropTypes.string,
  llmScreeningEnabled: PropTypes.bool,
  testId: PropTypes.string,
  sx: PropTypes.object,
};

export default ScreeningKindBadge;
